import { ILang, LangTypeEnum } from '~modules/lang/types/Lang';

import { ApiUrlVersionEnum } from './base/api/axios/AxiosEnums';

export const appConfig = {
  defaultApiVersion: ApiUrlVersionEnum.v1,

  accessTokenStorageKey: '_MFSurveyToolAccessToken', // _[projectName]AccessToken
  refreshTokenStorageKey: '_MFSurveyToolRefreshToken', // _[projectName]RefreshToken

  // i18n
  langStorageKey: '_LSATLang', // _[projectName]Lang
  defaultLanguage: LangTypeEnum.RU,
  languages: [
    { title: 'Русский', lang: LangTypeEnum.RU },
    // { title: 'English', lang: LangType.EN },
  ] as ILang[],
};
